// 判斷是否有值（統一轉字串＋trim；保留 0 / false）
const toStr = (v) => (v === null || v === undefined ? "" : String(v));
const hasValue = (v) => {
  const s = toStr(v).trim();
  return s !== "" && s !== "-";
};

// 取依賴答案
const questionDeps = (EAFormData, level, key) => {
  const arr = EAFormData?.[String(level)] || [];
  const found = arr.find((obj) => Object.hasOwn(obj, key));
  return found ? found[key] : null;
};

const testSingle = (cond, data) => {
  const v = questionDeps(data, cond.level, cond.key);
  const sv = toStr(v).trim();

  // eq：字串等值比較
  if ("eq" in cond) return sv === toStr(cond.eq).trim();

  // ne：值不存在直接通過；存在時做字串不等比較
  if ("ne" in cond) {
    if (!hasValue(v)) return true;
    return sv !== toStr(cond.ne).trim();
  }

  // notEmpty：看字串是否為空
  if (cond.notEmpty) return hasValue(v);

  // 預設：有值即通過
  return hasValue(v);
};

// 判斷哪個欄位需要顯示
export function shouldShow(field, data, secondData) {
  const { showIf, specialDataShouldIf } = field;

  // 如果兩個都沒設定 → 直接顯示
  if (!showIf && !specialDataShouldIf) return true;

  // 把判斷邏輯抽成小工具，避免重複
  const testCondition = (condition, targetData) => {
    if (!condition) return true;

    const anyGroup = Array.isArray(condition.any)
      ? condition.any
      : Array.isArray(condition.or)
      ? condition.or
      : null;

    const allGroup = Array.isArray(condition.all)
      ? condition.all
      : Array.isArray(condition.and)
      ? condition.and
      : null;

    const passAny = anyGroup
      ? anyGroup.some((sub) => testSingle(sub, targetData))
      : true;

    const passAll = allGroup
      ? allGroup.every((sub) => testSingle(sub, targetData))
      : true;

    if (anyGroup || allGroup) return passAny && passAll;

    // 單一條件物件
    return testSingle(condition, targetData);
  };

  const passNormal = testCondition(showIf, data);
  const passSpecial = testCondition(specialDataShouldIf, secondData);

  const visible = passNormal && passSpecial;
  // 如果兩個都有 → 必須都成立
  // 如果只有其中一個 → 就檢查那個

  return visible;
}
